import { render, staticRenderFns } from "./Onboard_system.vue?vue&type=template&id=31e63ed8"
import script from "./Onboard_system.vue?vue&type=script&lang=js"
export * from "./Onboard_system.vue?vue&type=script&lang=js"
import style0 from "./Onboard_system.vue?vue&type=style&index=0&id=31e63ed8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports